import { createCompanyAreaContext } from './shared_company_area_context'

export const COMPANY_AREA_CONTEXT_STORAGE_KEY = 'hapisumu.companyAreaContext'

export const {
  initArchiveAreaContext: initCompanyArchiveAreaContext,
  applyDetailAreaContext: applyCompanyDetailAreaContext,
} = createCompanyAreaContext({
  storageKey: COMPANY_AREA_CONTEXT_STORAGE_KEY,
  attributePrefix: 'company',
})
